import { render } from "./storysetchartboard.vue?vue&type=template&id=02e87b7c&scoped=true"
import script from "./storysetchartboard.vue?vue&type=script&lang=js"
export * from "./storysetchartboard.vue?vue&type=script&lang=js"

import "./storysetchartboard.vue?vue&type=style&index=0&id=02e87b7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02e87b7c"]])

export default __exports__